import { render } from "./standardFibre.vue?vue&type=template&id=ab360cee&scoped=true"
import script from "./standardFibre.vue?vue&type=script&lang=js"
export * from "./standardFibre.vue?vue&type=script&lang=js"

import "./standardFibre.vue?vue&type=style&index=0&id=ab360cee&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab360cee"]])

export default __exports__